import { WorkflowActionTypes } from 'src/app/models/RestApiCaller/Enums/workflow-action-types';
import { BaseActionData } from './base-action-data';

/**
 * Représente les données d'une action 'Change l'état d'une étape'.
 */
export class ChangeStepStateActionData extends BaseActionData {
    /**
     * Id de l'étape.
     */
    public stepId: number;

    /**
     * Id de l'état que doit prendre l'étape.
     */
    public stateId: number;

    /**
     * valeur indiquant si l'étape doit être activée si elle n'a pas commencée.
     */
    public activateStepIfNotStarted;

    /**
     * valeur indiquant si l'étape doit être activée si elle est terminée.
     */
    public activateStepIfCompleted;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowActionTypes.ChangeStepState);
    }

    /**
     * Retourne une copie d'une instance de ChangeStepStateActionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: ChangeStepStateActionData) {
        if (!!other) {
            const instance = new ChangeStepStateActionData();
            instance.stepId = other.stepId;
            instance.stateId = other.stateId;
            instance.activateStepIfNotStarted = other.activateStepIfNotStarted;
            instance.activateStepIfCompleted = other.activateStepIfCompleted;
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
